"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    basename(...args) { },
    resolve(...args) { },
    path(...args) { },
    join(...args) { },
};
